import { Close } from "@material-ui/icons";
import { Button, IconButton } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useSnackbar } from "notistack";
import { OutboundApi } from "service/api/outbound.api";
import { QUERY_KEYS } from "service/constant/query-keys";

export const useGetLogOutboundCalls = (params, options) => {
  return useQuery({
    queryKey: [QUERY_KEYS.OUTBOUND_CALL_LOGS, params],
    queryFn: async () => {
      const res = await OutboundApi.getLogOutboundCalls(params);
      return res.data?.data;
    },
    ...options,
  });
};

export const useExportLogOutboundCalls = (params, options, onClickView) => {
  const newParams = { ...params, exportReport: true };
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  return useQuery({
    queryKey: [QUERY_KEYS.OUTBOUND_CALL_LOGS_EXPORT, newParams],
    queryFn: async () => {
      await OutboundApi.getLogOutboundCalls(newParams);
      enqueueSnackbar(
        "Đã xuất cáo! Vui lòng truy cập lịch sử xuất báo cáo để tải file",
        {
          variant: "success",
          autoHideDuration: 15000,
          action: (snackbarKey) => (
            <>
              <Button
                variant="text"
                onClick={() => {
                  closeSnackbar(snackbarKey);
                  onClickView();
                }}
                sx={{ fontSize: 13, fontWeight: 700 }}
                color="inherit">
                Xem tại đây
              </Button>
              <IconButton
                onClick={() => closeSnackbar(snackbarKey)}
                color="inherit">
                <Close />
              </IconButton>
            </>
          ),
        }
      );
    },
    enabled: false,
    ...options,
  });
};
